import _ from 'lodash'

import Coupon from './coupon'

export default class CouponCollection {
  constructor(
    private coupons: Coupon[] = [],
    private commonLoaded: boolean = false,
    private loadedBrands: string[] = []
  ) {}

  get commonLoadDone(): boolean {
    return this.commonLoaded
  }

  get commonCoupons(): Coupon[] {
    return _.filter(this.coupons, (c) => {
      return c.isCommonCoupon
    })
  }

  brandLoadDone(brandEnglishName: string): boolean {
    return this.loadedBrands.indexOf(brandEnglishName) !== -1
  }

  brandCoupons(brandEnglishName: string): Coupon[] {
    return _.filter(this.coupons, (c) => {
      return c.brandEnglishName === brandEnglishName
    })
  }

  commonOrBrandCoupons(brandEnglishName: string): Coupon[] {
    return _.concat(
      this.commonCoupons,
      this.brandCoupons(brandEnglishName)
    )
  }

  commonOrBrandCouponsWithRange(brandEnglishName: string, startAt: number, limit: number): Coupon[] {
    return this.commonOrBrandCoupons(brandEnglishName).slice(startAt, startAt + limit)
  }

  addCoupons(coupons: Coupon[]) {
    this.coupons = _.concat(this.coupons, coupons)
  }

  setCommonLoaded() {
    this.commonLoaded = true
  }

  setBrandLoaded(brandEnglishName: string) {
    this.loadedBrands.push(brandEnglishName)
  }
}
